import LabRepository from "./LabRepository";

const resource = "/schedule";

export default {
  getAll(params) {
    return LabRepository.get(`${resource}?limit=all`, { params });
  },
  get(schedule_id, params) {
    return LabRepository.get(`${resource}/${schedule_id}`, { params });
  },
  create(payload) {
    return LabRepository.post(resource, payload);
  },
  update(schedule_id, payload) {
    return LabRepository.put(`${resource}/${schedule_id}`, payload);
  },
  suspend(schedule_id) {
    return LabRepository.delete(`${resource}/${schedule_id}`);
  },
  addSample(schedule_id, payload) {
    return LabRepository.post(`${resource}/${schedule_id}/samples`, {
      samples: payload
    });
  },
  deleteSample(schedule_id, payload) {
    return LabRepository.delete(`${resource}/${schedule_id}/samples`, {
      data: { samples: payload }
    });
  },
  syncSamples(schedule_id, payload) {
    return LabRepository.put(`${resource}/${schedule_id}/samples`, {
      samples: payload
    });
  },
  autoSchedule(schedule_id) {
    return LabRepository.get(`${resource}/${schedule_id}/auto-schedule`);
  },
  clearSchedule(schedule_id) {
    return LabRepository.get(`${resource}/${schedule_id}/clear-schedule`);
  },
  copySchedule(schedule_id, copy_id) {
    return LabRepository.post(`${resource}/${schedule_id}/copy-samples/${copy_id}`)
  }
};
